import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=6d55221b&lang=pug&"
import script from "./Bank.vue?vue&type=script&lang=ts&"
export * from "./Bank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports